const megaMenuColumns = [
  {
    sections: [
      {
        name: "Design & Development",
        links: [
          { name: "Web Design", href: "/web-design" },
          { name: "Shopify", href: "/shopify" },
          { name: "BigCommerce Development", href: "/bigcommerce" },
          { name: "Ecommerce Redesign", href: "/ecommerce-website-redesign" },
          {
            name: "Shopify Development",
            href: "/shopify-theme-customization",
          },
          { name: "Tampa Web Design", href: "/tampa" },
        ],
      },
      {
        name: "Migrations",
        links: [
          { name: "BigCommerce to Shopify", href: "/bigcommerce-to-shopify" },
          {
            name: "WooCommerce to Shopify",
            href: "/woocommerce-to-shopify-migration",
          },
          {
            name: "Ecommerce Migration",
            href: "/ecommerce-data-migration-services",
          },
          { name: "B2B Ecommerce", href: "/b2b-ecommerce-agency" },
        ],
      },
    ],
  },
  {
    sections: [
      {
        name: "SEO & AI Search",
        links: [
          { name: "SEO", href: "/seo" },
          { name: "Shopify SEO", href: "/shopify-seo" },
          { name: "BigCommerce SEO", href: "/bigcommerce-seo" },
          { name: "Ecommerce SEO Audit", href: "/ecommerce-seo-audit" },
          { name: "AI Optimization", href: "/ai-optimization" },
        ],
      },
      {
        name: "Paid Media & Conversion",
        links: [
          { name: "Google Ads", href: "/paid-search" },
          { name: "Google Shopping", href: "/google-shopping-management" },
          {
            name: "Google Merchant Center",
            href: "/google-merchant-center-services",
          },
          { name: "Social Media Marketing", href: "/social-media-marketing" },
          {
            name: "Conversion Rate Optimization",
            href: "/conversion-rate-optimization",
          },
        ],
      },
    ],
  },
  {
    sections: [
      {
        name: "Retention Marketing",
        links: [
          { name: "Email Marketing", href: "/email-marketing" },
          {
            name: "Klaviyo Management",
            href: "/klaviyo-email-marketing-agency",
          },
        ],
      },
      {
        name: "Support & Optimization",
        links: [
          { name: "VIP Support", href: "/vip-support" },
          {
            name: "Website Maintenance",
            href: "/ecommerce-website-maintenance",
          },
          { name: "Shopify Support", href: "/shopify-support-maintenance" },
          {
            name: "BigCommerce Support",
            href: "/bigcommerce-support-maintenance",
          },
          {
            name: "Website Speed Optimization",
            href: "/website-speed-optimization",
          },
          {
            name: "ADA Accessibility Optimization",
            href: "/ada-accessibility-optimization",
          },
          { name: "Ecommerce Consulting", href: "/ecommerce-consulting" },
          { name: "Ecommerce Audit", href: "/ecommerce-website-audit" },
        ],
      },
    ],
  },
];

export default megaMenuColumns;

export const footerMenuColumns = [
  ...megaMenuColumns.map((column) => ({
    ...column,
    sections: column.sections.map((section) =>
      section.name === "Retention Marketing"
        ? { ...section, links: [...section.links, { name: "Mailchimp to Klaviyo", href: "/mailchimp-to-klaviyo-migration" }] }
        : section,
    ),
  })),
  {
    sections: [
      {
        name: 'Company',
        links: [
          { name: 'Our Work', href: '/our-work' },
          { name: 'Case Studies', href: '/case-studies' },
          { name: 'About Us', href: '/about' },
          { name: 'Partners', href: '/partners' },
          { name: 'Careers', href: '/careers' },
          { name: 'Contact Us', href: '/contact-us' },
        ],
      },
      {
        name: 'Resources',
        links: [
          { name: 'Resources', href: '/resources' },
          { name: 'Growth Calculator', href: '/grow' },
          { name: 'UPS Resources', href: '/ups' },
        ],
      },
    ],
  },
]
